import { LitElement, html, css, unsafeCSS } from 'lit';
import classnames from 'classnames';

import request from '../../utils/request/request';
import Logger from '../../utils/logger/logger';
import config from '../../../shared/config/config';

import styles from './app-widget.component.scss';


class AppWidget extends LitElement {
  static properties = {
    appid: { type: Number },
    name: { type: String },
    description: { type: String },
    iconSrc: { type: String },
    iconSrcSet: { type: String },
    url: { type: String },
    rating: { type: String },
    platforms: { type: String },
    isWebView: { type: String },
    isWithoutDivider: { type: String },
  };

  static styles = css`${unsafeCSS(styles.toString())}`;

  // analogue of the componentDidMount
  // it is only needed when you insert a banner in the text editor to load app data dynamically
  async connectedCallback() {
    super.connectedCallback();

    if (this.name && this.description && this.iconSrc && this.iconSrcSet && this.url && this.platforms) return;

    try {
      const {
        name,
        shortDescription,
        icon,
        detailsUrl,
        rating,
        platforms,
      } = await request.get(`/api/apps/${this.appid}`);

      this.name = name;
      this.description = shortDescription;
      this.iconSrc = icon.src;
      this.iconSrcSet = icon.srcSet;
      this.url = detailsUrl;
      this.rating = String(rating);
      this.platforms = platforms;

      this.requestUpdate();
    } catch (error) {
      Logger.catchError('App data fetch have failed', error);
    }
  }

  render() {
    const isWebView = this.isWebView !== undefined;

    const containerClassList = classnames('app-widget', {
      'app-widget_web-view': isWebView,
      'app-widget_without-divider': this.isWithoutDivider !== undefined,
    });

    return html`
      <div class="${containerClassList}">
        <a class="app-widget__link-wrapper" href=${this.url}>
          <img
            class="${classnames('app-widget__icon', { 'app-widget__icon_rounded': !this.platforms.includes('Mac') })}"
            src="${this.iconSrc}"
            srcset="${this.iconSrcSet}"
            alt="${this.name}"
            width="80"
            height="80"
          />
          <div class="app-widget__content">
            <div class="app-widget__title">${isWebView ? this.name : this.description}</div>
            <div class="app-widget__description">${isWebView ? this.description : this.name}</div>
            <div class="app-widget__details">
              ${this.rating !== '0' ? html`
                <svg class="app-widget__rating-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M6.425 4.94A4.01 4.01 0 0 0 6 6.74V11c0 1.1.895 2 2 2h3.562c.856 0 1.617-.54 1.893-1.35l1.259-3.7c.442-1.29-.523-2.64-1.894-2.64H10V1.99a.99.99 0 0 0-1.87-.45l-1.705 3.4zM2.5 5.31A1.5 1.5 0 0 0 1 6.81v4.69a1.499 1.499 0 1 0 3 0V6.81a1.5 1.5 0 0 0-1.5-1.5z" opacity=".5" fill-rule="evenodd"/></svg>
                <div class="app-widget__rating">${this.rating}%</div>
              ` : undefined}
              ${this.platforms}
            </div>
            ${isWebView ? undefined : html`
              <div class="preview-app-button">
                <svg class="preview-app-button__icon" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m8 3.5c3 0 5.3333333 1.5 7 4.5-1.6666667 3-4 4.5-7 4.5s-5.33333333-1.5-7-4.5c1.66666667-3 4-4.5 7-4.5zm0 2.5c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2-.8954305 2-2-.8954305-2-2-2z" fill-rule="evenodd" opacity=".5"/></svg>
                <span class="preview-app-button__text">View app</span>
              </div>
            `}
          </div>
        </a>
        ${isWebView ? html`
          <a class="btn btn_outline-primary btn_sm" href="${this.url}">Learn more</a>
        ` : html`
          <a class="desktop-button__wrapper" href="${this.url}">
            <div class="desktop-button">View app</div>
            <div class="desktop-button__background"></div>
          </a>
        `}
      </div>
    `;
  }
}

const defineAppWidgetElement = () => {
  customElements.define(config.get('customElements').appWidget, AppWidget);
};

export default defineAppWidgetElement;
